export const deleteBonus = `mutation DeleteBonus($input: DeleteBonusInput!) {
    deleteBonus(input: $input) {
      id
    }
  }
  `;
